
import { useState } from 'react';

export default function Gallery() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const galleryImages = [
    {
      title: 'Garage Cleanout',
      image: 'https://public.readdy.ai/ai/img_res/76bb83b6cc6e766f9f934b71ba0185e8.jpg'
    },
    {
      title: 'Furniture Removal',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20furniture%20removal%20living%20room%20transformation%20old%20furniture%20removed%20clean%20empty%20room%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20junk%20removal%20results%20modern%20style&width=600&height=400&seq=gallery-tech-002&orientation=landscape'
    },
    {
      title: 'Estate Cleanout',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20estate%20cleanout%20transformation%20full%20house%20items%20becoming%20empty%20clean%20space%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20results%20modern%20style&width=600&height=400&seq=gallery-tech-003&orientation=landscape'
    },
    {
      title: 'Storage Unit',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20storage%20unit%20cleanout%20transformation%20packed%20storage%20unit%20becoming%20completely%20empty%20clean%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20style&width=600&height=400&seq=gallery-tech-004&orientation=landscape'
    },
    {
      title: 'Appliance Removal',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20appliance%20removal%20old%20refrigerator%20washer%20dryer%20removed%20clean%20empty%20space%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20style&width=600&height=400&seq=gallery-tech-005&orientation=landscape'
    },
    {
      title: 'Yard Cleanup',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20yard%20cleanup%20transformation%20cluttered%20yard%20with%20debris%20becoming%20clean%20organized%20outdoor%20space%20evening%20time%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20style&width=600&height=400&seq=gallery-tech-006&orientation=landscape'
    },
    {
      title: 'Foreclosure Cleanout',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20foreclosure%20property%20cleanout%20transformation%20abandoned%20items%20becoming%20empty%20clean%20property%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20style&width=600&height=400&seq=gallery-tech-007&orientation=landscape'
    },
    {
      title: 'Curbside Pickup',
      image: 'https://readdy.ai/api/search-image?query=before%20and%20after%20curbside%20pickup%20items%20at%20curb%20then%20clean%20empty%20curb%20evening%20time%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20industrial%20style&width=600&height=400&seq=gallery-tech-008&orientation=landscape'
    }
  ];

  return (
    <section id="gallery" className="py-24 bg-black relative overflow-hidden">
      {/* Background Grid */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.2) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.2) 1px, transparent 1px)',
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-cyan-400 text-sm font-bold tracking-[0.3em] uppercase mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            <span className="w-8 h-px bg-cyan-400"></span>
            Portfolio
            <span className="w-8 h-px bg-cyan-400"></span>
          </span>
          <h2 
            className="text-4xl md:text-5xl font-black text-white mb-4"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            OUR <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">WORK</span>
          </h2>
          <p className="text-xl text-gray-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            Before &amp; After Transformations
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {galleryImages.map((item, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg cursor-pointer"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="w-full h-56">
                <img
                  src={item.image}
                  alt={item.title}
                  className={`w-full h-full object-cover object-top transition-all duration-700 ${hoveredIndex === index ? 'scale-110' : 'scale-100'}`}
                />
              </div>
              
              {/* Overlay */}
              <div className={`absolute inset-0 bg-gradient-to-t from-black via-black/60 to-transparent transition-opacity duration-500 ${hoveredIndex === index ? 'opacity-100' : 'opacity-70'}`}></div>
              
              {/* Border Effect */}
              <div className={`absolute inset-0 border-2 transition-all duration-500 rounded-lg ${hoveredIndex === index ? 'border-cyan-400' : 'border-transparent'}`}></div>
              
              {/* Content */}
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <h3 className="text-white font-bold text-lg" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  {item.title}
                </h3>
                <p className={`text-cyan-400 text-sm transition-all duration-500 ${hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2'}`}>
                  View transformation
                </p>
              </div>

              {/* Corner Accent */}
              <div className={`absolute top-2 right-2 w-8 h-8 border-t-2 border-r-2 border-cyan-400 transition-opacity duration-500 ${hoveredIndex === index ? 'opacity-100' : 'opacity-0'}`}></div>
              <div className={`absolute bottom-2 left-2 w-8 h-8 border-b-2 border-l-2 border-cyan-400 transition-opacity duration-500 ${hoveredIndex === index ? 'opacity-100' : 'opacity-0'}`}></div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const contactSection = document.getElementById('contact');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="group inline-flex items-center gap-3 border-2 border-gray-600 text-white px-10 py-4 rounded-md text-lg font-bold tracking-wider hover:border-cyan-400 hover:text-cyan-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            REQUEST YOUR FREE QUOTE
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
